require('whatwg-fetch');
require('core-js/fn/string/includes');
require('core-js/fn/array/includes');



//////////////////
// WEBPACK FOOTER
// ../polyfills.js
// module id = ../polyfills.js
// module chunks = 0